import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { ITrendConfig } from '../../../../common-trend/common-trend.component';
import { ICellConfig } from '../base-cell/base-cell.component';
import { BaseCellComponent } from '../base-cell/base-cell.component';
import { FeatureFlagCollection } from '../../../../../../../shared/interfaces/feature-flag.interface';
import { FeatureFlagService } from '../../../../../services/feature-flag/feature-flag.service';

export interface IScoreCellConfig extends ICellConfig {
  score: number;
  isIncreaseImprovement?: boolean;
  previousValue?: number;
  showNoChange?: boolean;
}

@Component({
  selector: 'table-cell-score',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  styles: [
    `
      .score-cell {
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
      }
    `,
  ],
  standalone: false,
  template: `
    <div class="score-cell" #ref>
      @if (useDsScore) {
        <ds-score [value]="config.score"></ds-score>
      } @else {
        <span class="visuallyhidden">{{ 'n_of_t' | translate: [config.score, 100] }}</span>
        <span class="visible" aria-hidden="true">
          <span [class]="'badge ' + scoreClass" aria-hidden="true">{{ config.score }}</span
          >&nbsp;/&nbsp;100</span
        >
      }
    </div>
    @if (hasPreviousData) {
      <app-common-trend class="ms-2" [config]="trendConfig"></app-common-trend>
    }
  `,
})
export class ScoreCellComponent extends BaseCellComponent implements OnInit {
  public trendConfig: ITrendConfig;

  @Input() public config: IScoreCellConfig;

  constructor(
    protected renderer: Renderer2,
    private featureFlagService: FeatureFlagService,
  ) {
    super(renderer);
  }

  public get useDsScore(): boolean {
    return this.featureFlagService.variation(FeatureFlagCollection.scoreDesignSystem, true);
  }

  public get scoreClass(): string {
    if (typeof this.config?.score !== 'undefined') {
      if (this.config.score >= 0 && this.config.score <= 49) {
        return 'score-low';
      }
      if (this.config.score >= 50 && this.config.score <= 79) {
        return 'score-mid';
      }
      return 'score-high';
    }

    return null;
  }

  public get hasPreviousData(): boolean {
    return typeof this.config.previousValue === 'number';
  }

  public ngOnInit(): void {
    if (this.hasPreviousData) {
      this.buildTrendConfig();
    }
  }

  private buildTrendConfig(): void {
    this.trendConfig = {
      currentValue: this.config.score,
      previousValue: this.config.previousValue,
      isIncreaseImprovement: true,
      noChangePrefix: '-',
    };
  }
}
